import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CustomThemeProvider } from './contexts/ThemeContext';
import { SearchProvider } from './contexts/SearchContext';
import { CookieProvider } from './contexts/CookieContext';
import ExceptionalNavigation from './components/ExceptionalNavigation';
import CookieBanner from './components/CookieBanner';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ScrollToTopButton from './components/ScrollToTopButton';
import HomePage from './pages/HomePage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import SearchResultsPage from './pages/SearchResultsPage';
import TagPage from './pages/TagPage';
import CorporateDocumentationPage from './pages/CorporateDocumentationPage';
import CorporateDocumentationPostPage from './pages/CorporateDocumentationPostPage';
import LicensingPage from './pages/LicensingPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import PricingPage from './pages/PricingPage';
import SpecialPricingPage from './pages/SpecialPricingPage';
import DownloadPage from './pages/DownloadPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import PressPage from './pages/PressPage';
import SecurityToolsPage from './pages/SecurityToolsPage';
import SLAPage from './pages/SLAPage';
import DisclaimerPage from './pages/DisclaimerPage';
import CookiePreferencesPage from './pages/CookiePreferencesPage';
import { Box } from '@mui/material';

function AppContent() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <ExceptionalNavigation />
      <Box component="main" sx={{ flexGrow: 1 }}>
        <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/blog/search" element={<SearchResultsPage />} />
                <Route path="/blog/tag/:tag" element={<TagPage />} />
                <Route path="/blog/:slug" element={<BlogPostPage />} />
                <Route path="/docs/:section/:page" element={<CorporateDocumentationPostPage />} />
                <Route path="/docs" element={<CorporateDocumentationPage />} />
              
              {/* Additional pages */}
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/special-pricing" element={<SpecialPricingPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/careers" element={<div style={{padding: '100px 20px', textAlign: 'center'}}><h1>Careers - Coming Soon</h1><p>Join our team!</p></div>} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/press" element={<PressPage />} />
              <Route path="/tools" element={<SecurityToolsPage />} />
              <Route path="/download" element={<DownloadPage />} />
              <Route path="/licensing" element={<LicensingPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/sla" element={<SLAPage />} />
              <Route path="/disclaimer" element={<DisclaimerPage />} />
              <Route path="/cookie-preferences" element={<CookiePreferencesPage />} />
        </Routes>
      </Box>
      <Footer />
      <ScrollToTopButton />
      <CookieBanner />
    </Box>
  );
}

function App() {
  return (
    <CustomThemeProvider>
      <CookieProvider>
        <Router>
          <ScrollToTop />
          <SearchProvider>
            <AppContent />
          </SearchProvider>
        </Router>
      </CookieProvider>
    </CustomThemeProvider>
  );
}

export default App;
